export default {"src":"/_next/static/media/training-upload.c7363b31.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};